var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9375 5.60001L3.47498 34.4H36.525L19.9375 5.60001ZM19.9375 9.36251L33.275 32.5125H6.71248L19.9375 9.37501V9.36251Z",
    fill: "#FF8726"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0066 26.5698L18.504 28.0724L20.0066 29.575L21.5092 28.0724L20.0066 26.5698Z",
    fill: "#FF8726"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5375 25.125C20.9625 22.875 21.0875 21 21.0875 16.175V15.8125H18.8875V16.15C18.8875 20.975 19.025 22.8625 19.4375 25.1125H20.55L20.5375 25.125Z",
    fill: "#FF8726"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.3c24ed42c1dd5a72b014e7843161b1de.svg";
export { ForwardRef as ReactComponent };